var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',_vm._g(_vm._b({},'router-view',Object.assign({}, _vm.$attrs, _vm.$props),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }